module.exports = __webpack_public_path__ + "static/img/logo_default.45dcbc6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/logo_default.svg
// module id = xvBg
// module chunks = 0